// REACT, REDUX, HELMET //
import React, { useEffect } from "react";
import {
  BrowserRouter,
  NavLink,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

// PAGES & LAYOUTS //
// import Header from "../layouts/Header/Header";
import Footer from "../layouts/Footer/Footer";
import HomePage from "../pages/Home/HomePage";
import {
  PoliciesCookiesPage,
  PoliciesPrivacyPage,
  PoliciesTermsPage,
} from "../pages/Policies/PoliciesPage";
import NotFoundPage from "../pages/Exceptions/NotFoundPage";
import Cookie from "../layouts/Cookie/Cookie";

// STATES FROM SLICE //
import { getImgSrc, getLayoutHeaderHeight } from "../features/app/layoutsSlice";
import ServicePage from "../pages/Services/ServicesPage";
import companyLogo from "../assets/imgExport";
import AboutUsPage from "../pages/AboutUs/AboutUsPage";
import SustainabilityPage from "../pages/Sustainability/SustainabilityPage";
import CareersPage from "../pages/Careers/CareersPage";
import ContactPage from "../pages/Contact/ContactPage";
import Header from "../layouts/Header/Header";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const AppRoutes = () => {
  // TODO: get user which decides if account page is visible
  const imgSrc = useSelector(getImgSrc);

  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop />
      <main
        className={`relative z-[999] transition-all duration-500 ease-in-out  bg-white`}
        // className={`${headerHeight && "mt-[" + headerHeight + "px]"} relative transition-all duration-500 ease-in-out z-[999]`}
        style={{
          minHeight: `calc(100vh)`,
          WebkitMinHeight: `calc(100vh)`,
        }}
      >
        <Routes>
          <Route
            path="/about-us"
            element={
              <>
                <Helmet>
                  <title>About Us | Venti Maris</title>
                  <meta
                    name="description"
                    content="Learn about Venti Maris – our company background, mission and values, and the experienced leadership team driving our vision in heavy marine transport for offshore energy projects."
                  />
                  <meta
                    name="keywords"
                    content="Venti Maris company, marine transport history, offshore logistics values, leadership team, maritime expertise, London marine company."
                  />
                </Helmet>
                <AboutUsPage />
              </>
            }
          />
          <Route
            path="/sustainability"
            element={
              <>
                <Helmet>
                  <title>Sustainability | Venti Maris</title>
                  {/* <meta
                    name="description"
                    content=""
                  />
                  <meta
                    name="keywords"
                    content=""
                  /> */}
                </Helmet>
                <SustainabilityPage />
              </>
            }
          />
          <Route
            path="/careers"
            element={
              <>
                <Helmet>
                  <title>Careers | Venti Maris</title>
                  <meta
                    name="description"
                    content="Careers at Venti Maris – Join our team in maritime logistics and offshore transport. Discover job opportunities, our company culture, benefits, and how to apply to be part of the offshore wind revolution."
                  />
                  <meta
                    name="keywords"
                    content="Venti Maris jobs, maritime careers, offshore logistics jobs, marine transport employment, company culture, job openings, apply Venti Maris."
                  />
                </Helmet>
                <CareersPage />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <Helmet>
                  <title>Contact | Venti Maris</title>
                  <meta
                    name="description"
                    content="Contact Venti Maris – Get in touch for heavy marine transport services. Send us a message or find our London office address, phone number, and email to discuss your offshore transport needs."
                  />
                  <meta
                    name="keywords"
                    content="Venti Maris contact, marine transport inquiries, offshore logistics contact, London marine services address, heavy transport quote, contact form."
                  />
                </Helmet>
                <ContactPage />
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
                <Helmet>
                  <title>Services | Venti Maris</title>
                  <meta
                    name="description"
                    content="Venti Maris company, marine transport history, offshore logistics values, leadership team, maritime expertise, London marine company."
                  />
                  <meta
                    name="keywords"
                    content="marine logistics services, freight broker, sea transport, offshore ship charter, vessel rental intermediary, heavy lift transport."
                  />
                </Helmet>
                <ServicePage />
              </>
            }
          />
          <Route path="/policies/cookies" element={<PoliciesCookiesPage />} />
          <Route path="/policies/privacy" element={<PoliciesPrivacyPage />} />
          <Route path="/policies/terms" element={<PoliciesTermsPage />} />
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>Venti Maris</title>
                  <meta
                    name="description"
                    content="Welcome to Venti Maris, a UK-based consultancy and service provider, specializing in the sea transport of major components for the offshore wind industry. "
                  />
                  <meta
                    name="keywords"
                    content="heavy marine transport, offshore wind logistics, sea cargo, freight broker, ship charter, ship rental, marine transportation services, London."
                  />
                </Helmet>
                <HomePage />
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                <Helmet>
                  <title>404 | Venti Maris</title>
                  <meta name="description" content="Page not found." />
                </Helmet>
                <NotFoundPage />
              </>
            }
          />
        </Routes>
      </main>
      <Footer />
      <Cookie />
    </BrowserRouter>
  );
};
